import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// Shared PDF export helper for the Reports family: takes a flat row array +
// column definitions and produces a titled, paginated PDF (title/subtitle,
// print datetime, page numbers). Relocated out of App.js so standalone
// report components (e.g. the POS Back Office reports) can use it too
// without duplicating this logic.
export const exportReportToPDF = ({ title, subtitle, footerNote, columns, rows, filename, orientation = 'portrait' }) => {
  const doc = new jsPDF(orientation);
  const pageWidth = doc.internal.pageSize.getWidth();
  const printDatetime = new Date().toLocaleString('en-US', {
    month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true
  });

  autoTable(doc, {
    startY: 30,
    margin: { top: 30, bottom: 16 },
    head: [columns.map(c => c.header)],
    body: rows.map(row => columns.map(c => (row[c.key] === undefined || row[c.key] === null || row[c.key] === '') ? '-' : row[c.key])),
    theme: 'grid',
    headStyles: { fillColor: [79, 70, 229], textColor: 255, fontSize: 8, fontStyle: 'bold' },
    bodyStyles: { fontSize: 7, cellPadding: 2 },
    columnStyles: columns.reduce((acc, c, idx) => {
      if (c.align === 'right') acc[idx] = { halign: 'right' };
      return acc;
    }, {}),
    didParseCell: (data) => {
      const row = rows[data.row.index];
      if (row && row.__bold) {
        data.cell.styles.fontStyle = 'bold';
      }
    },
    didDrawPage: () => {
      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      doc.text(title, pageWidth / 2, 12, { align: 'center' });
      if (subtitle) {
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.text(subtitle, pageWidth / 2, 18, { align: 'center' });
      }
      const pageHeight = doc.internal.pageSize.getHeight();
      doc.setFontSize(7);
      if (footerNote) doc.text(footerNote, 10, pageHeight - 10);
      doc.text(`Print Datetime: ${printDatetime}`, 10, pageHeight - 6);
    }
  });

  const totalPages = doc.internal.getNumberOfPages();
  const pageHeight = doc.internal.pageSize.getHeight();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(7);
    doc.text(`Page ${i} of ${totalPages}`, pageWidth - 10, pageHeight - 6, { align: 'right' });
  }

  doc.save(filename);
};
